export enum SettlementPayrollModalTypes {
    OPEN_SETTLEMENTPAYROLL_MODAL = '[auth] OPEN_SETTLEMENTPAYROLL_MODAL',
    CLOSE_SETTLEMENTPAYROLL_MODAL = '[auth] CLOSE_SETTLEMENTPAYROLL_MODAL',
    REACTIVE_SETTLEMENTPAYROLL_COL = '[auth] REACTIVE_SETTLEMENTPAYROLL_COL'
}